import { z } from "zod";

/**
 * Lead capture validation schema (client-side).
 *
 * Mirrors the server-side Pydantic model so validation rules live in one
 * conceptual place. Used by react-hook-form via `zodResolver`.
 */
export const leadSchema = z.object({
  name: z
    .string()
    .min(2, "Please enter your name")
    .max(80, "That name looks too long"),
  email: z.string().email("Enter a valid email address"),
  company: z.string().max(120).optional().or(z.literal("")),
  budget: z.string().optional().or(z.literal("")),
  service: z.string().optional().or(z.literal("")),
  message: z
    .string()
    .min(10, "Tell us a little more — at least 10 characters")
    .max(2000, "That message is a bit long"),
});

export type LeadFormValues = z.infer<typeof leadSchema>;

export const budgetOptions = [
  { value: "10-25k", label: "$10k – $25k" },
  { value: "25-50k", label: "$25k – $50k" },
  { value: "50-100k", label: "$50k – $100k" },
  { value: "100k+", label: "$100k+" },
  { value: "not-sure", label: "Not sure yet" },
];

export const serviceOptions = [
  { value: "product-design", label: "Product Design" },
  { value: "engineering", label: "Full-Stack Engineering" },
  { value: "mobile", label: "Mobile Applications" },
  { value: "strategy", label: "Product Strategy" },
  { value: "design-systems", label: "Design Systems" },
  { value: "other", label: "Something else" },
];
